"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getGetters_1 = require("./util/getGetters");
class BaseEvent {
    constructor(id, time, eid) {
        this._id = id;
        this._time = time instanceof Date ? time.getTime() : time;
        this._eid = eid;
    }
    /**
     * The event id. Event ID should be unique as it *may* be subject to
     * deduplication at the event broker service.
     */
    get id() {
        return this._id;
    }
    /**
     * Unix timestamp in milliseconds that the event occurred.
     */
    get time() {
        return this._time;
    }
    /**
     * (Optional) episode id. Related events can have an episode id.
     */
    get eid() {
        return this._eid;
    }
    /**
     * JSON-encodes the event object
     * @returns
     */
    toString() {
        return JSON.stringify(this.toObject());
    }
    /**
     * Returns a plain JavaScript object.
     * @returns
     */
    toObject() {
        return {
            type: this.type,
            ...getGetters_1.getInstanceGetters(this, true).reduce((memo, value) => {
                Reflect.set(memo, value, Reflect.get(this, value));
                return memo;
            }, {}),
        };
    }
}
exports.default = BaseEvent;
//# sourceMappingURL=baseEvent.js.map